import { createContext } from 'utils/react-helpers';

const [ChecklistProvider, useChecklist] = createContext({
  name: 'ChecklistContext',
});

export { ChecklistProvider, useChecklist };
